import { PencilSimple, Plus, UserCircle } from '@phosphor-icons/react';
import React, { useRef, useState } from 'react';
import { Button } from 'app/components';
import UploadModal from '../../event-create/components/step-4/uploadModal';


const Avatar = (props) => {
  const { businessConfig, onSaveAvatar } = props;

  const [isModalOpen, setIsModalOpen ] = useState(false);
  const inputRef = useRef(null);

  const handleImageUpload = (file) => {
    onSaveAvatar(file, () => setIsModalOpen(false));
  }
  
  const handleModalSubmit = (file) => {
    handleImageUpload(file);
  }
  return (
    <div className={businessConfig?.logo ? 'w-full' : 'w-fit' }>
      <div className=' flex flex-col items-center relative w-fit pb-8 '> 
        {businessConfig?.logo ? (
          <img
            src={businessConfig?.logo}
            alt="profile-img"
            className='rounded-full w-[112px] h-[112px] object-cover'
          />
        ) : (
          <div className='border border-grey-30 bg-grey-10 p-8 rounded-full w-fit'> 
            <UserCircle weight='fill' 
              color='#B7B7B7' 
              size='48'
              onClick={() => setIsModalOpen(true)}  
            /> 
          </div> )}
       
        <div className=' avatar-button absolute top-24 z-10'>
          <input type="file"
            onChange={handleImageUpload}
            hidden
            ref={inputRef}
            accept="image/*" />
          <Button
            type='tertiary'
            iconLeft={businessConfig?.logo ? (<PencilSimple weight='fill'
              size='20'
              color='#101010'/>)
              :(<Plus size='20'
                color='#101010'
              />)}
            rounded={true}
            size='small'
            onClick={() => setIsModalOpen(true)}
          >{businessConfig?.logo ? 'Edit': 'Upload'}</Button>
        </div>
      </div>
      <UploadModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        uploadTitle="Upload display picture"
        uploadFileName="Upload"
        onSubmit={handleModalSubmit}
        reuploadText="Re-upload"
      />
    </div>
  )
}

export default Avatar;